// extracted by mini-css-extract-plugin
export default {"colorWrapper":"NewIdeas_colorWrapper__2DEk6","newIdeas":"NewIdeas_newIdeas__Y9UlI","trial":"NewIdeas_trial__i3jFi","trialButton":"NewIdeas_trialButton__nT0Yf"};